import { Order, useOrderState } from 'entities/orders';
import timer from 'assets/icons/timer-icon-white.svg';
import menComing from 'assets/icons/men-coming-icon.svg';
import document from 'assets/icons/document-icon.svg';
import table from 'assets/icons/table-icon-white.svg';
import { TopButtonsContainerVariants } from 'widgets/orderDetail/ui/types';

export const useOrderDetailHeaderTitle = (
	order: Order,
	variant: TopButtonsContainerVariants,
) => {
	const {
		isVisitEnd,
		isVisitProgress,
		isVisitDelay,
		isVisitWaiting,
		isOrderExists,
		isWaitingList,
		isCanceled,
		isVisitMissed,
	} = useOrderState(order);

	let title;
	let iconSrc = '';
	let color = variant === 'default' ? 'main' : 'white';

	if (isOrderExists) {
		title = '';
	}

	if (isVisitEnd) {
		title = 'Архивная карточка';
		iconSrc = document;
	}

	if (isVisitProgress) {
		title = 'В зале';
		iconSrc = table;
	}

	if (isVisitDelay) {
		title = 'Гость задерживается';
		iconSrc = timer;
	}

	if (isVisitWaiting) {
		title = 'Гость скоро придёт';
		iconSrc = menComing;
	}

	if (isWaitingList) {
		title = 'Лист ожидания';
	}

	if (isCanceled) {
		title = 'Отменено';
		color = 'danger';
	}

	if (isVisitMissed) {
		title = 'Гости не пришли';
		color = 'danger';
	}

	return {
		title,
		iconSrc,
		color,
	};
};
